import {Component, Input} from "@angular/core";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {Session} from "../../../../model/session.model";
import {SessionManagerService} from "../../../../services/session-manager.service";

@Component({
  selector: "admin-page-first",
  templateUrl: "./first.component.html",
  styleUrls: ["./first.component.css"]
})
export class AdminPageFirstComponent {

  @Input() title: string = "";

  session?: Session;

  constructor(
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService
  ) {
    this.session = this.sessionManager.session;
  }

  getFrontends(): {name: string, icon: string}[] {
    return this.viewManager.currentFrontends;
  }

  getCurrentDateTime() {
    return new Date().toUTCString()
  }

}
